import Avatar from 'components/Avatar';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../constants';
import { TResFemaleRanking } from 'types';

function RankingItem({ rank, user }: TResFemaleRanking) {
  const navigate = useNavigate();
  const openProfile = () =>
    navigate(routes.DETAIL_FEMALE.replace(':id', String(user.id)));

  return (
    <article className="ranking-card">
      <div className="ranking-card__rank" aria-label={`${rank}位`}>
        <strong>{String(rank).padStart(2, '0')}</strong>
        <span>{rank === 1 ? 'TOP' : 'RANK'}</span>
      </div>
      <button
        type="button"
        className="ranking-card__identity"
        onClick={openProfile}
        aria-label={`${user.nickname}のプロフィールを見る`}
      >
        <span className="ranking-card__name">{user.nickname}</span>
      </button>
      <button
        type="button"
        className="ranking-card__photo"
        onClick={openProfile}
        aria-label={`${user.nickname}のプロフィールを見る`}
      >
        <Avatar url={user.avatar} containerClassName="ranking-card__avatar" />
      </button>
    </article>
  );
}

export default RankingItem;
